import request from '@/utils/request';
import { RParam, type R } from '@/api';
import type { User } from '@/api/system/user/model';
import type { UpdatePasswordParam } from './model';
import {
  dataFillCurrInfo,
  getAppId,
  getDataScopeId,
  getRoleCode,
  StorageUtil
} from '@/utils/lzd-util';

/**
 * 获取当前登录用户的个人信息/菜单/权限/角色
 */
export async function getUserInfo(
  dataScopeId?: number,
  roleCode?: string
): Promise<User> {
  const res = await request.post<R<User>>(
    '/bsl/tenant/auth/user/data-scope',
    dataFillCurrInfo({ dataScopeId, roleCode })
  );
  if (res.data.code === 0 && res.data.data) {
    // 把当前租户id保存到本地
    StorageUtil.set('currTenantId', res.data.data.tenantId);
    return res.data.data;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 修改当前登录用户的密码
 */
export async function updatePassword(
  data: UpdatePasswordParam
): Promise<string> {
  const res = await request.post<R<unknown>>(
    '/bsl/tenant/user/update/password',
    {
      appId: getAppId(),
      dataScopeId: getDataScopeId(),
      roleCode: getRoleCode(),
      update: RParam.buildEdit(data, (k: string) => k !== 'seq')
    }
  );
  if (res.data.code === 0) {
    return res.data.message ?? '修改成功';
  }
  return Promise.reject(new Error(res.data.message));
}
